/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicFilterNotificationRuleAssetScopeConditionDto } from './PublicFilterNotificationRuleAssetScopeConditionDto';

export type PublicAssetFilterNotificationRuleAssetScopeConditionDto = (PublicFilterNotificationRuleAssetScopeConditionDto & {
    /**
     * List of the assets in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    assets?: Array<string>;
    /**
     * Operator of the condition
     */
    operator?: PublicAssetFilterNotificationRuleAssetScopeConditionDto.operator;
} & {
    /**
     * List of the assets in the condition in URI format. <a href="https://docs.siffletdata.com/docs/uri">[Read more about URIs]</a>
     */
    assets: Array<string>;
    /**
     * Operator of the condition
     */
    operator: PublicAssetFilterNotificationRuleAssetScopeConditionDto.operator;
});

export namespace PublicAssetFilterNotificationRuleAssetScopeConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
